import { render, staticRenderFns } from "./ApiVideo.vue?vue&type=template&id=c95d92ce&scoped=true&"
import script from "./ApiVideo.vue?vue&type=script&lang=js&"
export * from "./ApiVideo.vue?vue&type=script&lang=js&"
import style0 from "./ApiVideo.vue?vue&type=style&index=0&id=c95d92ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d92ce",
  null
  
)

export default component.exports